import { type FC, memo } from 'react';
import { useTranslation } from 'react-i18next';
import { CAMPAIGN_INFO_TYPES } from 'features/campaigns';
import { useCampaignInfoDisplay } from '../../../../../hooks/info/useCampaignInfoDisplay';
import type { CampaignInfoDisplayStyles } from '../../css/base/CampaignInfoDisplayStyles';

interface CampaignFinishedStateProps {
  campaignId?: string;
  styles: CampaignInfoDisplayStyles;
}

const CampaignFinishedState: FC<CampaignFinishedStateProps> = ({ campaignId, styles }) => {
  const { t } = useTranslation();
  const { getWrapperClassName, getDataAttributesByInfoType } = useCampaignInfoDisplay(campaignId);
  const wrapperClassName = getWrapperClassName(CAMPAIGN_INFO_TYPES.TIMER);
  const dataAttributes = getDataAttributesByInfoType(CAMPAIGN_INFO_TYPES.TIMER);

  return (
    <div className={`${wrapperClassName} ${styles.finishedContainer}`} {...dataAttributes}>
      <span className={`${styles.dynamicValue} ${styles.finishedText}`} {...dataAttributes}>
        {t('campaigns.finished', 'Finished')}
      </span>
    </div>
  );
};

export default memo(CampaignFinishedState);
